angular.module('zc.zenclerkS')
  .component('zcsProfile', {
    templateUrl: '/templates/zenclerk_s/directives/profile/profile.html',
    controller: zcsProfile,
  });

zcsProfile.$inject = ['$scope', '$state', 'Devise', 'Environment', '$translate'];
function zcsProfile($scope, $state, Devise, Environment, $translate) {
  const vm = this;
  vm.state = {};
  vm.css = {};

  vm.environment = 'production';
  Environment.get()
    .then(environment => {
      vm.environment = environment;
    });

  vm.availableLanguages = $translate.getAvailableLanguageKeys();

  // User info
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  Devise.getCurrentUser().then(user => {
    vm.user = _.merge({}, user);
  });

  // Navigation
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  vm.state.nav = 'info'; // default view
  vm.nav = item => {
    vm.state.nav = item;
  };

  // Info modification
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  vm.updateInfo = user => {
    Devise.updateInfo(user)
      .then(res => {
        $translate.use(res.lang);
        moment.locale(res.lang);
        $scope.$parent.$emit('userInfoUpdated');
      });
  };

  // Password modification
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  vm.updatePassword = user => {
    Devise.updatePassword(user.current_password, user.password, user.password_confirmation)
      .then(function(res) {
        vm.user.current_password = vm.user.password;
        vm.user.password = '';
        vm.user.password_confirmation = '';
      });
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/profile/zcs_profile.directive.js